import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Footer } from '../../models/footer/footer.model';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public today: number = Date.now();
  public footer: Footer = {
    footer:false,
    icon_whatsapp:{
      active:false,
      link:""
    },
    items:[],
    items1: []
  };

  public version:string = environment.version;

  // MC CATFER-90 Variables usadas para las distintas secciones del footer. Se extraen de esta forma para poder tener mayor control en el layout porque las columnas no son simétricas
  public FERRETTI_1: any;
  public FERRETTI_2: any;
  public FERRETTI_3: any;


  constructor(private http:HttpClient) { }

  ngOnInit(): void {
    this.getFooter();
  }

  private getFooter(){
    const url = './assets/data/footer/footer.json';
    return this.http.get<Footer>(url).subscribe((resp) =>{
      this.footer = resp;
      // MC CATFER-90 Extraigo las secciones del footer
      this.FERRETTI_1 = this.footer.items1?.[0]?.FERRETTI_1 ?? null;
      this.FERRETTI_2 = this.footer.items1?.[1]?.FERRETTI_2 ?? null;
      this.FERRETTI_3 = this.footer.items1?.[2]?.FERRETTI_3 ?? null;
    });

  }

}
